const CAMPAIGN_KEYS = ["utm_source", "utm_medium", "utm_campaign"];
const CAMPAIGN_VALUE = /^[a-z0-9][a-z0-9_-]{0,39}$/;

export const getValidatedCampaign = (search = window.location.search) => {
  const params = new URLSearchParams(search);
  return CAMPAIGN_KEYS.reduce((campaign, key) => {
    const value = params.get(key)?.trim().toLowerCase();
    if (value && CAMPAIGN_VALUE.test(value)) campaign[key] = value;
    return campaign;
  }, {});
};

const capture = (event, properties = {}) => {
  const client = window.posthog;
  if (!client?.capture || client.has_opted_out_capturing?.()) return;
  client.capture(event, properties);
};

export const trackCoachingLanding = (locale) =>
  capture("coaching_landing_viewed", { page_locale: locale, ...getValidatedCampaign() });

export const trackCoachingCta = (location) =>
  capture("coaching_cta_clicked", { cta_location: location, ...getValidatedCampaign() });

export const trackConfirmedCoachingSubmission = () =>
  capture("coaching_contact_submitted", getValidatedCampaign());